import React from 'react';
import {
  Modal,
  Paper,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxHeight: '90%',
    maxWidth: '500px',
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    borderRadius: '8px',
    outline: 'none',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '32px',
    textAlign: 'center',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: '16px',
    top: '16px',
    color: theme.palette.text.primary,
  },
  successIcon: {
    fontSize: '64px',
    color: '#4CAF50',
    marginBottom: '24px',
    alignSelf: 'center',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: '16px',
    fontFamily: 'Montserrat, sans-serif',
  },
  description: {
    fontSize: '16px',
    color: theme.palette.text.primary,
    lineHeight: 1.5,
    marginBottom: '32px',
    fontFamily: 'Montserrat, sans-serif',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    padding: '12px 32px',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: 500,
    textTransform: 'none',
    fontFamily: 'Montserrat, sans-serif',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.9,
    },
  },
}));

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modalContainer}
    >
      <Paper className={classes.modal}>
        <Box className={classes.modalContent}>
          <CheckCircleIcon className={classes.successIcon} />

          <Typography className={classes.title}>
            ¡Formulario enviado con éxito!
          </Typography>

          <Typography className={classes.description}>
            Te enviaremos un correo con tu usuario y clave para revisar tu
            información y recibir tu plan de estudios.
          </Typography>

          <Box className={classes.buttonContainer}>
            <Button
              className={classes.button}
              onClick={onClose}
              variant="contained"
              size="large"
            >
              Listo
            </Button>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

export default SuccessModal;
